<template>
  <CCard>
    <CCardHeader>
      <strong>{{ this.$lang.dashboard.header.recent_resource_response }}</strong>
      <span style="float: right;">
        <CBadge color="success">{{ count }}</CBadge>
      </span>
    </CCardHeader>
    <CCardBody>
      <CDataTable class="mb-0 table-outline" hover :items="tableItems" :fields="tableFields"
                  @row-clicked="rowClickHandler" head-color="light" no-sorting>
        <td slot="resource" slot-scope="{ item }">
          <span :title="item.resource">{{ trimfunction(item.resource, 15) }}</span>
        </td>
        <td slot="response" slot-scope="{ item }">
          <span :title="item.response">{{ trimfunction(item.response, 15) }}</span>
        </td>
        <td slot="username" slot-scope="{ item }">
          <span :title="item.username">{{ trimfunction(item.username, 15) }}</span>
        </td>
      </CDataTable>
      <CRow v-if="showProfile" style="margin-top: 2px">
        <CCol class="col-12 text-right">
          <button title="View All Profile" v-on:click="viewResourceResponses" class="btn btn-light btn-block mb-1">
            View All
          </button>
        </CCol>
      </CRow>
    </CCardBody>
  </CCard>
</template>
<script>
import Vue from "vue";
import {ServerTable} from "vue-tables-2";
import store from "../../store/store";
import {Mixin} from "/src/mixins/index.js";
import {dashboardrecentResourceResponseList} from "../../store/url";

Vue.use(ServerTable, {}, false);
export default {
  name: "RecentResourceResponse",
  mixins: [Mixin],
  data() {
    return {
      self: this,
      count: 0,
      showProfile: false,
      moduleDashboardrecentResourceResponseList: dashboardrecentResourceResponseList,
      tableItems: [],
      tableFields: [
        {key: "resource", label: this.$lang.dashboard.recentResourceResponse.resource},
        {key: "response", label: this.$lang.dashboard.recentResourceResponse.response},
        {key: "username", label: this.$lang.dashboard.recentResourceResponse.username},
      ],
    };
  },
  mounted() {
    let self = this;
    store.commit("showLoader", false); // Loader Off
    axios.get(this.listUrlApi(this.moduleDashboardrecentResourceResponseList))
        .then((response) => {
          self.tableItems = response.data.data;
          self.count = response.data.count;
          if (response.data.data.length > 0) {
            self.showProfile = true;
          }
        });
  },
  methods: {
    rowClickHandler(item) {
      this.$router.push({path: `resource/view/${item.resourceId}`});
    },
    viewResourceResponses() {
      this.$router.push({path: `resource`});
    },
  },
};
</script>
<style>
div .error {
  color: red;
}

.hasError label {
  color: red;
}
</style>
